import {
  Chip,
  Stack,
  Tooltip,
  Typography,
  type SxProps,
  type Theme,
} from '@mui/material'
import { useId, type ReactElement } from 'react'
import { Helmet } from 'react-helmet-async'

type Props = {
  title: string
  isBeta?: boolean
  titleSx?: SxProps<Theme>
}

/**
 * ヘッダーで使用するタイトル
 */
export const HeaderTitle = ({ title, isBeta, titleSx }: Props) => {
  const headerLabelId = useId()

  const wrapWithTooltip = (children: ReactElement) => {
    if (!isBeta) return children

    return (
      <Tooltip
        title={
          <>
            {'この画面は正式リリース前の'}
            <br />
            {'検証版として提供しています'}
          </>
        }
      >
        {children}
      </Tooltip>
    )
  }

  return wrapWithTooltip(
    <Stack
      direction="row"
      alignItems="center"
      sx={{ minWidth: 0, overflow: 'hidden' }}
    >
      <Helmet>
        <title>{title} | カミナシ レポート</title>
      </Helmet>
      <Typography
        component="h1"
        id={headerLabelId}
        sx={[
          {
            fontSize: 20,
            fontWeight: 700,
            mb: 0,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
          ...(Array.isArray(titleSx) ? titleSx : titleSx ? [titleSx] : []),
        ]}
      >
        {title}
      </Typography>
      {isBeta && (
        <Chip label="β版" variant="pale" color="primary" sx={{ ml: 1 }} />
      )}
    </Stack>,
  )
}
